<template>
  <div class="Organisation-information">
    <CreateOrganisation
      ref="createOrganisation"
      @loadingChange="loadingChange"
      @createSuccess="organisationSuccess"
    />
    <div class="register-content-footer" v-if="!isSignIn">
      <el-button
        class="active-btn"
        @click="submit"
        :loading="loading || verifyLoading"
        >{{ $t('text.sign_up').toUpperCase() }}</el-button
      >
    </div>
    <div slot="footer" class="text-right mt-30" v-else>
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="loading || verifyLoading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </div>
  </div>
</template>

<script>
import CreateOrganisation from '@/components/register/CreateOrganisation'
export default {
  data() {
    return {
      verifyLoading: false,
      loading: false
    }
  },
  props: {
    isSignIn: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CreateOrganisation
  },
  methods: {
    loadingChange(val) {
      this.loading = val
    },
    organisationSuccess() {
      this.verifyUser()
    },
    closeDialog() {
      this.$parent.$parent.closeDialog()
    },
    submit() {
      this.$refs.createOrganisation.submit()
    },
    verifyUser() {
      this.verifyLoading = true
      this.$store
        .dispatch('user/verifyUser')
        .then(response => {
          this.verifyLoading = false
          if (response.data.success) {
            this.redirectToHomePage()
          } else {
            this.showErrorMsg(response.data.msg)
          }
        })
        .catch(() => {
          this.verifyLoading = false
        })
    },
    redirectToHomePage() {
      this.showFullScreenLoading()
      this.$store.dispatch('patient/fetchPatients').then(() => {
        this.$store.dispatch('filter/getUserFilter').then(response => {
          this.closeFullScreenLoading()
          if (response instanceof Error) {
            this.showErrorMsg(this.$t('text.sign_in_failed'))
          } else {
            this.$router.push({ path: '/' })
          }
        })
      })
    },
    showErrorMsg(msg) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${msg}</div>` +
          `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.warning'),
        {
          confirmButtonText: this.$t('text.ok').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          showCancelButton: false
        }
      )
    },
    showFullScreenLoading() {
      this.fullScreenLoading = this.$loading({
        lock: true,
        text: this.$t('text.signing_in'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    closeFullScreenLoading() {
      if (this.fullScreenLoading) {
        this.fullScreenLoading.close()
      }
    }
  }
}
</script>
